import {
  IRequestIntroductionRequest,
  IRequestIntroductionResponse,
  ISummaryRecommendationsResponse,
} from "../contracts/Favorability";
import { IZeosApiResponse } from "../contracts/ZeosApi";
import { getDataAsync, postDataAsync } from "../ZeosApiExecutor";
import { IFavorability } from "./interfaces/IFavorability";

const API_BASE_URL = `/Favorability`;

export const Favorability: IFavorability = {
  getSummary: async (
    propertyId: number,
    zeosUserId: number
  ): Promise<IZeosApiResponse<ISummaryRecommendationsResponse>> => {
    return await getDataAsync<ISummaryRecommendationsResponse>(
      `${API_BASE_URL}/Summary/${propertyId}?zeosUserId=${zeosUserId}`,
      ""
    );
  },

  requestIntroduction: async (
    request: IRequestIntroductionRequest
  ): Promise<IZeosApiResponse<IRequestIntroductionResponse>> => {
    return await postDataAsync<IRequestIntroductionResponse>(
      `${API_BASE_URL}/RequestIntroduction`,
      request
    );
  },
};
